export default {
  title: 'Scurtături',
  links: {
    reservations: 'Rezervări',
    orders_portal: 'Autentificare terminal',
    closed: 'Închis?',
    menu: 'Schimbă meniul',
    payouts: 'Rapoarte plăți',
    opening_hours: 'Program de lucru',
  },
};
